import React from "react";
import { useDispatch } from "react-redux";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { getAnalytics } from "firebase/analytics";
import { Store } from "react-notifications-component";
import "animate.css";

import { setFirebaseToken } from "../redux/reducers/page";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAt5ZGRdZGofwnTAkrEhAKbue1PP4LdfRg",
  authDomain: "meshirt-9b1ad.firebaseapp.com",
  projectId: "meshirt-9b1ad",
  storageBucket: "meshirt-9b1ad.appspot.com",
  messagingSenderId: "875010998850",
  appId: "1:875010998850:web:5699c80cfb0102a78363db",
  measurementId: "G-M9YXSQX1VY",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

getAnalytics(firebaseApp);

const RequestForToken = () => {
  const dispatch = useDispatch();

  const getFirebaseToken = async () => {
    getToken(messaging, {
      vapidKey:
        "BLN0bSTAQEiMkprSmvFot_xZ1AF9RXTd7yndLvbXuX5WCqNqDqsNh8GXLCREPwQ8Ny85lF2e-lf7Cm016-ARjkg",
    })
      .then((currentToken) => {
        if (currentToken) {
          dispatch(setFirebaseToken(currentToken));
          console.log("current token for client: ", currentToken);
          // Perform any other neccessary action with the token
        } else {
          getFirebaseToken();
          // Show permission request UI
          // alert(
          //   "No registration token available. Request permission to generate one."
          // );
        }
      })
      .catch((err) => {
        getFirebaseToken();
        //  alert("An error occurred while retrieving token. ", err);
      });
  };
  React.useEffect(() => {
    // alert('RequestForToken');
    getFirebaseToken();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default RequestForToken;
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      Store.addNotification({
        title: payload.notification.title,
        message: payload.notification.body,
        type: "info",
        insert: "top",
        showIcon: true,
        dismissIcon: true,
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__flipInY"],
        animationOut: ["animate__animated", "animate__flipOutX"],
        dismiss: {
          duration: 8000,
          onScreen: true,
        },
      });
      resolve(payload);
    });
  });
// rnc__notification-title
// rnc__notification-message
